import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Stack,
  SxProps,
  Theme,
} from "@mui/material";
import { useState } from "react";

import { deleteUser } from "./../../../../api/pps";
import useNotify from "../../../../hooks/useNotify";
import { useSetDeleteCustomerStore } from "../../../../stores/ppsStore";
import Text from "../../../atoms/Text";
import ExclamationIcon from "../../../icons/ui/ExclamationIcon";

type Props = {
  omneId: string;
  omneName: string;
  customStyle?: SxProps<Theme>;
};

const ButtonActionDelete = ({ omneId, omneName, customStyle }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const setDeleteCustomer = useSetDeleteCustomerStore();
  const { setNotifySuccess, setNotifyError } = useNotify();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDelete = (event: { stopPropagation: () => void }) => {
    event.stopPropagation();
    setLoading(true);
    // delete user
    deleteUser(omneId.toString())
      .then(res => {
        if (res.data) {
          if (
            res.data &&
            res.data.message === "User account successfully deleted"
          ) {
            setDeleteCustomer(omneId.toString());
          }
          setNotifySuccess(res.data?.message);
        }
      })
      .finally(() => {
        setLoading(false);
        handleCloseModal();
      })
      .catch(error => {
        setNotifyError(error?.data?.message);
      });
  };

  return (
    <Box data-testid="action-delete-component">
      <Button
        variant="secondary"
        size="small"
        onClick={handleOpenModal}
        sx={customStyle}
        data-testid="action-button"
      >
        Delete Account
      </Button>

      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        data-testid="modal-component"
      >
        <Box
          width={532}
          bgcolor="mono.white"
          borderRadius={2.5}
          pb={3}
          overflow="hidden"
        >
          <Box px={2.5} py={2} bgcolor="mono.light.grey">
            <Text variant={"title_medium"}>Delete Item</Text>
          </Box>

          <Stack p={3} alignItems="center">
            <ExclamationIcon width={48} height={48} />

            <Stack mt={2} mb={4} alignItems="center">
              <Text variant={"body_large"}>
                Are you sure you want to delete this Omne account?
              </Text>
              <Text variant={"title_small"}>{omneId}</Text>
              {omneName && <Text variant={"title_small"}>{omneName}</Text>}
            </Stack>

            <Stack direction="row" spacing={1} width={256}>
              <Button
                variant="secondary"
                size="small"
                fullWidth={true}
                onClick={handleCloseModal}
                data-testid="close-modal-button"
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                size="small"
                fullWidth={true}
                disabled={loading}
                startIcon={loading && <CircularProgress size={20} />}
                onClick={handleDelete}
                data-testid="delete-button"
              >
                Delete
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </Box>
  );
};

export default ButtonActionDelete;
